import { render, staticRenderFns } from "./CreateManuiFirstComp.vue?vue&type=template&id=435271fc&scoped=true&"
import script from "./CreateManuiFirstComp.vue?vue&type=script&lang=js&"
export * from "./CreateManuiFirstComp.vue?vue&type=script&lang=js&"
import style0 from "./CreateManuiFirstComp.vue?vue&type=style&index=0&id=435271fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435271fc",
  null
  
)

export default component.exports